import React, { Fragment, useEffect, useState } from "react";
import "../../templateform/templateform.css";
import Accordion from "react-bootstrap/Accordion";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";


function PricingPlans(props) {
  const { data, setData, languageData, handleResetData } = props;

  // State to keep track of selected options
  const [selectedOptions, setSelectedOptions] = useState([]);

  const options = [
    { value: "Affordable Rates", label: "Affordable Rates" },
    { value: "Personalized Workouts", label: "Personalized Workouts" },
    { value: "Nutritional Guidance", label: "Nutritional Guidance" },
    { value: "Progress Tracking", label: "Progress Tracking" },
    { value: "Customized Training", label: "Customized Training" },
    { value: "Dietary Counseling", label: "Dietary Counseling" },
    { value: "Regular Progress Check", label: "Regular Progress Check" },
    { value: "Flexible Scheduling", label: "Flexible Scheduling" },
    { value: "One-on-One Coaching", label: "One-on-One Coaching" },
    { value: "Advanced Training Techniques", label: "Advanced Training Techniques" },
    { value: "24/7 Support", label: "24/7 Support" },
    { value: "Exclusive Access to Workshops", label: "Exclusive Access to Workshops" },
  ];


  const addNewEntery = () => {
    let newOdj = {
      heading: "",
      subheading: "",
      description: "",
      price: "",
      button_text: "",
      status: false,
    };
    let newArr = { ...data }
    let arrItem = [...newArr.items, newOdj]
    newArr['items'] = arrItem
    setData(newArr);
  };

  const removeEntery = (index) => {
    let newArr = { ...data };
    let arrItem = newArr.items;
    if (arrItem.length > 1) {
      arrItem.splice(index, 1);
    }
    newArr['items'] = arrItem
    setData(newArr);
  };

  const handleInputValue = (index, name, value) => {
    let newArr = { ...data };
    let arr = [...newArr.items]
    arr[index][name] = value
    setData({ ...data, items: arr })
  }
  const handleToggle = (e) => {
    e.stopPropagation(); // Prevent the Accordion from toggling
    setData({
      ...data,
      status: !data?.status
    });
  };


  const handleFeatureAdd = (value, index, mainIndex) => {
    let newArr = { ...data };
    let arr = [...newArr.items]
    let mainFeature = arr[mainIndex]
    let featuresData = mainFeature.features

    if (featuresData != undefined && featuresData.length > 0) {
      featuresData[index] = value
    } else {
      featuresData = [value]
    }
    mainFeature.features = featuresData;
    arr[mainIndex] = mainFeature
    setData({ ...data, items: arr })
  }
  const addPlanFeature = (index) => {
    let newArr = { ...data };
    let arr = [...newArr.items]
    let mainFeature = arr[index]
    let featuresData = mainFeature.features

    if (featuresData != undefined && featuresData.length > 0) {
      featuresData = [...featuresData, ""]
    } else {
      featuresData = [""]
    }
    mainFeature.features = featuresData;
    arr[index] = mainFeature
    setData({ ...data, items: arr })
  }
  const removeFeature = (index, mainIndex) => {
    let newArr = { ...data };
    let arr = [...newArr.items]
    let mainFeature = arr[mainIndex]
    let featuresData = mainFeature.features

    if (featuresData != undefined && featuresData.length > 1) {
      featuresData.splice(index, 1)
    }
    mainFeature.features = featuresData;
    arr[mainIndex] = mainFeature
    setData({ ...data, items: arr })
  }

  return (
    <Fragment>
      <Accordion.Header>
        <div className="drop_header_dflex">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/assets/images/icon/rupee-symbol.png" alt="Add Pricing Plans" width="10%" /> {" "}
            <span style={{ marginLeft: '15px' }}>   {languageData?.addPricingPlans}</span>
          </div>
          <div style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}>
            {/* <Form.Check
              defaultChecked={data?.status}
              style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
              type="switch"
              className="custom-switch"
              onChange={handleToggle}
              onClick={(e) => e.stopPropagation()} // Prevent event bubbling
            /> */}
            <label
              className="custom-toggle-ios m-1"
              style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
              onClick={(e) => e.stopPropagation()} // Prevent event bubbling
            >
              <input
                type="checkbox"
                checked={data?.status}
                onChange={handleToggle}
              />
              <span className="slider-ios">
                {data?.status ? 'Show' : 'Hide'}
              </span>
            </label>

          </div>
        </div>
      </Accordion.Header>
      {data &&
        <Accordion.Body>
          <div className="row ">
            <div className="col-lg-6 col-md-6">
              <div className="input-field-box">
                <div className="heading_lable_box">
                  <label className="forn_title">{languageData?.heading}:</label>
                </div>
                <input
                  placeholder="Enter Title ..."
                  className="form-control"
                  name='title'
                  value={data.headingTitle.value}
                  onChange={(e) => setData({ ...data, headingTitle: { ...data.headingTitle, value: e.target.value } })}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="input-field-box">
                <div className="heading_lable_box">
                  <label className="forn_title">{languageData?.description}:</label>
                </div>
                <textarea
                  placeholder="Description ..."
                  className="form-control pb-5"
                  value={data.description.value}
                  onChange={(e) => setData({ ...data, description: { ...data.description, value: e.target.value } })}
                />
              </div>
            </div>
          </div>
          {data.items.length > 0 && data.items.map((item, index) => (
            <div key={index}>
              <div className="row new_fild_shadow" style={{ background: '#f8f8ee', borderRadius: 10 }}>
                {index > 0 && (
                  <div className="sav-proj-btn">
                    <Button
                      style={{ borderRadius: 50, fontSize: 10, background: '#ff966a', border: 0, color: '#000', fontWeight: 400, float: 'right' }}
                      onClick={() => removeEntery(index)}>
                      <i className="fa fa-times" aria-hidden="true"></i>
                    </Button>
                  </div>
                )}
                <div className="col-lg-6 col-md-6">
                  <div className="input-field-box">
                    <label className="forn_title">{languageData?.heading}:</label>
                    <input
                      placeholder="Heading..."
                      className="form-control"
                      value={item.heading}
                      onChange={(e) => handleInputValue(index, 'heading', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="input-field-box">
                    <label className="forn_title">{languageData?.subHeading}:</label>
                    <input
                      placeholder="Sub heading..."
                      className="form-control"
                      value={item.subheading}
                      onChange={(e) => handleInputValue(index, 'subheading', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="input-field-box">
                    <label className="forn_title">{languageData?.price}:</label>
                    <input
                      placeholder="Ex. 125"
                      className="form-control"
                      value={item.price}
                      onChange={(e) => handleInputValue(index, 'price', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="input-field-box">
                    <label className="forn_title">{languageData?.buttonText}:</label>
                    <input
                      placeholder="Button text"
                      className="form-control"
                      value={item.button_text}
                      onChange={(e) => handleInputValue(index, 'button_text', e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-lg-12 col-md-12">
                  <div className="input-field-box">
                    <label className="forn_title">{languageData?.features}:</label>
                  </div>
                  <div className="row">
                    {item.features && item.features.length > 0 && item.features.map((featur, ind) => (
                      <div className="col-lg-6 col-md-6" item={index}>
                        <div className="input-field-box" style={{ display: 'flex' }}>
                          {/* <label className="forn_title">{languageData?.features}:</label> */}
                          <input
                            placeholder="Essential Tookit"
                            className="form-control"
                            value={featur}
                            onChange={(e) => handleFeatureAdd(e.target.value, ind, index)}
                            style={{ marginRight: '5px' }}
                            maxLength={50}
                          />
                          <Button
                            style={{ borderRadius: 50, fontSize: 10, background: '#ff966a', border: 0, color: '#000', fontWeight: 400, float: 'right', padding: '5px' }}
                            onClick={() => removeFeature(ind, index)}>
                            <i className="fa fa-times" aria-hidden="true" style={{ margin: '0px' }}></i>
                          </Button>
                          {/* <select className="form-control" onChange={(e)=> handleFeatureAdd(e.target.value, ind, index)} value={item.features[ind]}>
                            <option>Select One</option>
                            {options.length > 0 && options.map((opt, i) => (
                              <option key={i}>{opt.value}</option>
                            ))}
                          </select> */}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>


                {/*  <div className="col-lg-12 col-md-12">
                  <div className="input-field-box">
                    <label className="forn_title">{languageData?.features}:</label>
                  </div>
                  <div className="row">
                    {item.features && item.features.length > 0 && item.features.map((featur, ind) => (
                      <div className="col-lg-6 col-md-6" item={index}>
                        <div className="input-field-box">
                          {/* <label className="forn_title">{languageData?.features}:</label> */}
                {/* <input
                          placeholder="Essential Tookit"
                          className="form-control"
                          value={item.button_text}
                          onChange={(e) => handleInputValue(index, 'button_text', e.target.value)}
                        /> 
                          <select className="form-control" value={item.features[ind]}>
                            <option>Select One</option>
                            {options.length > 0 && options.map((opt, i) => (
                              <option key={i}>{opt.value}</option>
                            ))}
                          </select>
                          {/* <div>
                      <Select
                      isMulti
                      options={options}
                      value={selectedOptions}
                      onChange={setSelectedOptions}
                      />
                      </div> 
                        </div>
                      </div>
                    ))}
                  </div>
                </div> */}
                <div className="col-lg-6 col-md-6">
                  <div className="input-field-box">
                    <br />
                    <Button
                      style={{ mt: '2rem', borderRadius: 50, width: 100, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      size='md'
                      onClick={() => addPlanFeature(index)}
                    >
                      {languageData?.addMore}
                    </Button>
                  </div>
                </div>
              </div>
              {index === data.items.length - 1 && (
                <div className="sav-proj-btn">
                  {/* <Button
                    onClick={addNewEntery}
                    style={{ borderRadius: 50, width: 100, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                    size='md'
                  >
                    {languageData?.addMore}
                  </Button> */}
                  <Button
                    style={{ borderRadius: 50, width: 100, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500, marginLeft: 20 }}
                    size='md'
                    onClick={() => handleResetData('pricing_plans')}
                  >
                    {languageData?.reset}
                  </Button>
                </div>
              )}
            </div>
          ))}
        </Accordion.Body>
      }
    </Fragment>
  );
}
export default PricingPlans;